import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const faqItems = [
  {
    question: "Qu'est-ce que BET-Partners ?",
    answer: "BET-Partners est une plateforme qui permet à ses partenaires de gagner de l'argent grâce aux paris sportifs sans parier eux-mêmes, en parrainant des joueurs sur des bookmakers comme 1xbet, BetWinner, 1win, MelBet ou LineBet.",
  },
  {
    question: 'Comment devenir partenaire BET-Partners ?',
    answer: "Inscrivez-vous gratuitement sur BET-Partners, attirez de nouveaux joueurs vers les bookmakers partenaires, puis recevez une commission pour chaque joueur parrainé. Aucun investissement de départ n'est requis.",
  },
  {
    question: 'Quelle commission puis-je gagner ?',
    answer: 'En créant une caisse de dépôt et retrait avec BET-Partners, vous recevez 5% de commission sur les dépôts et 2% sur les retraits effectués par vos joueurs, avec des paiements réguliers chaque semaine.',
  },
  {
    question: 'Est-ce gratuit de rejoindre BET-Partners ?',
    answer: "Oui, l'inscription sur BET-Partners est entièrement gratuite, que ce soit comme partenaire ou comme caissier de dépôt et retrait.",
  },
  {
    question: 'Comment contacter le support ?',
    answer: 'Vous pouvez nous contacter par WhatsApp au +226 77 17 02 02, par Telegram ou par email à support@bet-partners.com pour toute question.',
  },
];

const FaqSection = () => {
  return (
    <Box sx={{ padding: { xs: '30px 5%', sm: '50px 10%' }, backgroundColor: '#f8f9fa' }}>
      <Typography variant="h5" component="h2" gutterBottom align="center" sx={{ mb: 4, fontWeight: 'bold' }}>
        Questions fréquentes
      </Typography>
      {faqItems.map((item, index) => (
        <Accordion key={index}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography component="h3" sx={{ fontWeight: 'bold' }}>{item.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2" color="text.secondary">{item.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default FaqSection;
